import React from 'react'
import { Icon } from './LightBulb.elements'

type Props = {
  className?: string
}

export const LightBulbIcon = ({ className }: Props) => (
  <Icon
    viewBox="0 0 24 24"
    aria-hidden
    focusable={false}
    role="img"
    className={className}
    fill="none"
  >
    <path d="M14.4 16.158l-.5-.866-.5.29v.576h1zm-4.8 0h1v-.577l-.5-.289-.5.866zM15.8 12a3.798 3.798 0 01-1.9 3.292l1 1.732A5.798 5.798 0 0017.8 12h-2zM12 8.2a3.8 3.8 0 013.8 3.8h2A5.8 5.8 0 0012 6.2v2zM8.2 12A3.8 3.8 0 0112 8.2v-2A5.8 5.8 0 006.2 12h2zm1.9 3.292A3.798 3.798 0 018.2 12h-2a5.798 5.798 0 002.9 5.024l1-1.732zm.5 3.108v-2.242h-2V18.4h2zm-.2-.2c.11 0 .2.09.2.2h-2a1.8 1.8 0 001.8 1.8v-2zm3.2 0h-3.2v2h3.2v-2zm-.2.2c0-.11.09-.2.2-.2v2a1.8 1.8 0 001.8-1.8h-2zm0-2.242V18.4h2v-2.242h-2zM9 21h6v.5a1.5 1.5 0 01-1.5 1.5h-3A1.5 1.5 0 019 21.5V21z" fill="#173A68"/>
    <path stroke="#173A68" strokeWidth="2" d="M11.8 4.8v-3M16.893 6.493l2.121-2.121M7.107 6.493L4.986 4.372M19.2 11.8h3M5 11.8H2"/>
  </Icon>
)
